import { emojiReg, mobileReg } from "@/utils/regs";
import StorageUtils from "@/utils/StorageUtils"
import {
  CheckMerchantBillCodeWithBillInfo, RobotRecognizeMessage,
} from "@/api-server/modules/defaultServer";

import store from "@/store"

export const LINK_MAN = 'linkMan'
export const LINK_MAN_PHONE = 'linkManPhone'

export const editAddressInit = {
  // newReceiverInfo: '',
  newReceiverName: '',
  newReceiverPhone: '',
  newReceiverProvince: '',
  newReceiverProvinceId: '',
  newReceiverCity: '',
  newReceiverCityId: '',
  newReceiverCounty: '',
  newReceiverCountyId: '',
  newReceiverAddress: '',
}

export const editPhoneInit = {
  newReceiverName: '',
  newReceiverPhone: '',
}

export const initFormData = {
  billCode: "",
  orderTypeParent: "",
  orderType: "",
  claimAmount: "",
  description: "",
  linkMan: StorageUtils.get(LINK_MAN, true) || store.getters['user/userName'],
  linkManPhone: StorageUtils.get(LINK_MAN_PHONE, true) || store.state?.user?.userInfo?.mobile,
  ...editAddressInit,
  ...editPhoneInit,
  pictureList: [],
  audioList: [],
  expressPackage: "",
  itemName: "",
};

export const rules =  (editFormData: any, otherFormData: any, handleBind: any, workOrderTypes: any) => {
  const rules = {
    billCode: [
      { required: true, message: "请输入运单号", trigger: "blur" },
      {
        validator: (rule: any, billCode: string, callback: any) => {
          CheckMerchantBillCodeWithBillInfo.fetch({
            billCode: billCode
          }, { errType: 'all', notMessage: true }).then(({ data }: { data: any}) => {
            data.data.receiveName && !editFormData.value.newReceiverName && (editFormData.value.newReceiverName = data.data.receiveName)
            data.data.receiveMobile && !editFormData.value.newReceiverPhone && (editFormData.value.newReceiverPhone = data.data.receiveMobile)
            otherFormData.value.siteCode = data.data.assignSiteCode
            otherFormData.value.siteName = data.data.siteName
            otherFormData.value.siteMobile = data.data.siteMobile
            otherFormData.value.partnerId = data.data.elecId
            callback()
          }).catch((error) => {
            if (error.errCode === 'E502' || error.errCode === 'ELE_NOT_BIND') {
              handleBind(error?.data?.elecId || '', error.errCode)
            }
            callback(error.errMessage)
          })
        }, trigger: "blur"
      }
    ],
    orderTypeParent: [{ required: true, message: "请选择售后类型", trigger: "change" }],
    linkMan: [{ required: true, message: "请输入发起人姓名", trigger: "blur" }],
    linkManPhone: [
      { required: true, message: "请输入发起人手机号", trigger: "blur" },
      { pattern: mobileReg, message: "手机号不符合格式", rigger: "blur" },
    ],
  }
  if(workOrderTypes.value) {
    rules['orderType'] = [{ required: true, message: "请选择类型", trigger: "change" }]
  }
  // 理赔-破损
  if(['claim_damaged', 'claim_shortage', 'claim_loss'].includes(editFormData.value.orderType)) {
    rules['claimAmount'] = [
      {
        validator: (rule: any, claimAmount: string, callback: any) => {
          if (!claimAmount) return callback()
          // 数字校验
          const isNum = /^\d+(\.\d+)?$/
          if(!isNum.test(claimAmount)){
            callback('请输入数字')
          }
          if (Number(claimAmount) > 10000 || Number(claimAmount) <= 0) {
            callback('物品价值必须0~10000元范围内')
          }
          // 小数数值支持小数点后2位
          const reg = /^\d+\.\d{0,2}$/
          if(claimAmount.indexOf('.') !== -1) {
            if(!reg.test(claimAmount)) callback('支持小数点后2位')
          }else { // 非小数
            callback()
          }
        }
      }
    ]
  }
  return rules
};

export const rules0 =  (editFormData: any, otherFormData: any, handleBind: any, workOrderTypes: any) => {
    return {
      ...rules(editFormData, otherFormData, handleBind, workOrderTypes)
    }
}


export const rules1 = (editFormData: any, otherFormData: any, handleBind: any, workOrderTypes: any) => {
  return {
    ...rules(editFormData, otherFormData, handleBind, workOrderTypes),
    newReceiverPCC: [
      {
        validator: (rule: any, value: boolean, callback: any, handleBind: any, workOrderTypes: any) => {
          if (!editFormData.value.newReceiverCounty) {
            callback(new Error("请选择省市区"));
          } else {
            callback();
          }
        },
      },
    ],
    newReceiverAddress: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
    newReceiverName: [{ required: true, message: "请输入收件人姓名", trigger: "blur" }],
    newReceiverPhone: [
      { required: true, message: "请输入收件人手机号", trigger: "blur" },
      { pattern: mobileReg, message: "手机号不符合格式", rigger: "blur" },
    ],
  }
};

export const rules2 = (editFormData: any, otherFormData: any, handleBind: any, workOrderTypes: any) => {
  return {
    ...rules(editFormData, otherFormData, handleBind, workOrderTypes),
    newReceiverName: [{ required: true, message: "请输入收件人姓名", trigger: "blur" }],
    newReceiverPhone: [
      { required: true, message: "请输入收件人手机号", trigger: "blur" },
      { pattern: mobileReg, message: "手机号不符合格式", rigger: "blur" },
    ],
  }
}


export const initReForm = {
  billCode: '',
  orderTypeParent: '',
  orderType: '',
  operateType: '',
  claimAmount: '',
  workCode: '',
  incidentId: '',
  description: '',
  pictureList: [],
  audioList: [],
  videoList: [],
  linkMan: '',
  linkManPhone: '',
}

export const reRules = {
  description: [
    { required: true, message: "请输入描述信息", trigger: "blur" },
    {
      validator: (rule: any, description: string, callback: any) => {
        if (emojiReg.test(description)) {
          callback('请输入正确的描述信息')
        } else {
          callback()
        }
      }
    }
  ],
}
